import {
  HTTP_INTERCEPTORS,
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { APP_INITIALIZER, ApplicationConfig, ErrorHandler, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { InMemoryScrollingFeature, InMemoryScrollingOptions, provideRouter, TitleStrategy, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';
import { ApplicationinsightsAngularpluginErrorService } from '@microsoft/applicationinsights-angularplugin-js';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { routes } from './app.routes';
import { TranslateInitializerService } from './core/i18n/translate-initializer.service';
import { HttpLoaderFactory } from './core/i18n/translate-loader.factory';
import { LanguageInterceptor } from './core/interceptors/language.interceptor';
import { TelemetryInterceptor } from './core/interceptors/telemetry.interceptor';
import { AuthGuard } from './services/auth/auth-guard';
import { WithCredentialsInterceptor } from './services/auth/with-credentials-interceptor';
import { TelemetryService } from './services/telemetry/telemetry.service';
import { SiteTitleStrategy } from './site/site-title.strategy';

export function initializeApp(translateInitializer: TranslateInitializerService) {
  return () => translateInitializer.initialize();
}

export function initializeTelemetry(telemetryService: TelemetryService) {
  return () => {
    telemetryService.init();
    return Promise.resolve();
  };
}

const scrollConfig: InMemoryScrollingOptions = {
  scrollPositionRestoration: 'top',
  anchorScrolling: 'enabled',
};

const inMemoryScrollingFeature: InMemoryScrollingFeature =
  withInMemoryScrolling(scrollConfig);

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding(), inMemoryScrollingFeature),
    provideHttpClient(withInterceptorsFromDi()),
    provideHttpClient(),
    provideAnimationsAsync(),
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
        }
      })
    ),
    AuthGuard,
    { provide: TitleStrategy, useClass: SiteTitleStrategy },
    {
      provide: ErrorHandler,
      useClass: ApplicationinsightsAngularpluginErrorService
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [TranslateInitializerService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeTelemetry,
      deps: [TelemetryService],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: WithCredentialsInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LanguageInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TelemetryInterceptor,
      multi: true,
    },
  ],
};
